const useManualRefinementImageList = (manualRefinementState, setState) => {

    const setApproved = (i, curClass) => {
        const copyImagesManual = JSON.parse(JSON.stringify(manualRefinementState.manualImages));
        let isApproved = 'approved' in copyImagesManual[i] && !copyImagesManual[i].approved;

        if (curClass) {
            copyImagesManual[i].detectedClass = {
                tagId: curClass.tagId,
                clusterId: curClass.clusterId
            };
            isApproved = false;
        } else if (isApproved) {
            copyImagesManual[i].detectedClass = manualRefinementState.classes[manualRefinementState.index];
        } else if ('detectedClass' in copyImagesManual[i]) {
            delete copyImagesManual[i].detectedClass;
        }
        copyImagesManual[i].approved = isApproved;
        setState({manualImages: copyImagesManual});
    };

    const removeChosenClass = (i) => {
        const copyImagesManual = JSON.parse(JSON.stringify(manualRefinementState.manualImages));

        copyImagesManual[i].detectedClass = null;
        setState({manualImages: copyImagesManual});
    };

    /***
     * getNumberOfApprovedImages - count the images that have been approved
     */
    const getNumberOfApprovedImages = () => manualRefinementState.manualImages.filter((item) => item.approved === true).length;

    return {
        setApproved,
        removeChosenClass,
        getNumberOfApprovedImages};
};

export default useManualRefinementImageList;
